<template>
  <b-navbar fixed-top shadow is-warning type="is-white" id="nav">
    <template slot="brand">
      <b-navbar-item tag="router-link" to="/">
        <img src="../assets/spring2.png" alt="Springbit, Inc." />
      </b-navbar-item>
    </template>
    <template slot="end">
      <b-navbar-item to="/" tag="router-link" :active="$route.name === 'home'">
        Home
      </b-navbar-item>
      <b-navbar-item tag="router-link" to="/capabilities" :active="$route.name === 'capabilities'">
        Capabilities
      </b-navbar-item>
      <b-navbar-item tag="router-link" to="/services" :active="$route.name === 'services'">
        Services
      </b-navbar-item>
      <b-navbar-item tag="router-link" to="/jobs" :active="$route.name === 'jobs'">
        Jobs
      </b-navbar-item>
      <b-navbar-item to="/contact" tag="router-link" :active="$route.name === 'contact'">
        Contact
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
export default {
  name: 'Navbar',
};
</script>
